import { useSearchTableFromRoute } from '@aibees/elephant/hooks/use-obtain-search-type-from-route';
import { SearchTable } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { TagAction } from '../types';

/**
 * Returns the `TagAction`s to offer in see-all-popup / tag configs, derived
 * from the current route's search table.
 *
 * On the People / Company search tables the user is inside an active search,
 * so the "existing search" actions are included alongside the "new search"
 * ones. Everywhere else there is no active search to add into, so only the
 * "new search" actions apply.
 */
export function useTagActions(): TagAction[] {
  const table = useSearchTableFromRoute();

  return useMemo(
    () =>
      table === SearchTable.People || table === SearchTable.Company
        ? [
            TagAction.INCLUDE_IN_EXISTING_SEARCH,
            TagAction.INCLUDE_IN_NEW_SEARCH,
            TagAction.EXCLUDE_IN_EXISTING_SEARCH,
            TagAction.EXCLUDE_IN_NEW_SEARCH,
          ]
        : [TagAction.INCLUDE_IN_NEW_SEARCH, TagAction.EXCLUDE_IN_NEW_SEARCH],
    [table]
  );
}
